import React from 'react';
import {
  BrowserRouter as Router, 
  Switch,
  Route,
  Link
  } from 'react-router-dom';
import Menu from '../components/menu/menu.js';
import './app.css';
import Home from './home';
import Content from './configuration-content.json';
import ContentEn from './configuration-content-en.json';
import logo from '../assets/logo.png';
import Footer from './footer';
import Services from './services';
import Contact from './contact';

export default class App extends React.Component {

  constructor(props) {
    super(props);
    const lang = new URLSearchParams(window.location.search).get('lang') === 'en' ? 'en' : 'es';
    this.state = {
      lang,
      content: lang === 'en' ? ContentEn : Content
    };
  }

  render() {
    const { content } = this.state;
    return (
      <Router>
        <header>
          <Link to="/"><img src={logo} alt="logo" /> </Link>
          <Menu menu={content.menu}/>
        </header>

        <Switch>
          <Route exact path="/">
            <Home content={content.home}/>
          </Route>
          <Route path="/servicios/:service">
            <Services services={content.services} />
          </Route>
          <Route path="/nosotros">
            <Services services={content.services} />
          </Route>
          <Route path="/contact">
            <Contact serviceApi={content.serviceApi} sendTo={content.sendTo}/>
          </Route>
        </Switch>

        <Footer footer={content.footer} />
      </Router>
    );
  }
}
